import { Component, inject, OnInit } from '@angular/core';
import { AuthService } from '../../shared/services/auth.services';
import { Router } from '@angular/router';
import { LoadingService } from '../../shared/services/loading.service';

/**
 * Componente de callback do Keycloak.
 * Recebe o redirect do KC apos o login, processa o authorization code
 * via OAuthService e carrega os dados do usuario do backend.
 */
@Component({
  selector: 'app-auth-callback',
  templateUrl: './callback.component.html',
})
export class CallbackComponent implements OnInit {
  private authService = inject(AuthService);
  private router = inject(Router);
  private loadingService = inject(LoadingService);

  async ngOnInit(): Promise<void> {
    // Se ja esta autenticado (ex: F5 no callback), vai direto para home
    if (this.authService.isAuthenticated()) {
      this.router.navigate(['/']);
      return;
    }

    this.loadingService.open();

    try {
      // Processa o retorno do KC: troca o code por tokens, carrega userInfo do backend
      const loggedIn = await this.authService.initOAuthFlow();

      if (loggedIn) {
        this.router.navigate(['/']);
      } else {
        // Se nao conseguiu logar (ex: tokens invalidos), vai para login
        this.router.navigate(['/login']);
      }
    } catch (error) {
      console.error('Erro ao processar callback do Keycloak:', error);
      this.router.navigate(['/login']);
    } finally {
      this.loadingService.close();
    }
  }
}
